appConfig.getModule()
    .controller('appController', ['$scope', '$rootScope', '$stateParams', '$state', '$timeout', '$filter', '$location', 'AUTH_EVENTS', 'authService', 'commonService', 'errorService', 'PAGINATION_DEFAULT', 'modalService', 'translationsService', 'FONT_FAMILY', 'FONT_SIZE',
        function ($scope, $rootScope,$stateParams, $state, $timeout, $filter, $location, AUTH_EVENTS, authService, commonService, errorService, PAGINATION_DEFAULT, modalService, translationsService, FONT_FAMILY, FONT_SIZE) {

            (function init() {      
                $scope.websiteUrl = _WEBSITE_URL || '';
                $rootScope.appTitle = 'APP_TITLE'; //'DFA Dashboard'; // _APP_NAME
                $rootScope.appBroserTitle = 'APP_TITLE';//'DFA Dashboard';
                $rootScope.langDir = "ltr";
                $rootScope.passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[&@#$])[A-Za-z\d$@$!%*?&]{8,}/;
                $rootScope.currentUser = null;
                $scope.credentials = {
                    username: '',
                    password: ''
                }
                $scope.registration = {
                    username: '',
                    password: '',
                    email: '',
                    fname: '',
                    lname: ''
                }
                $scope.loginFailed = false;
                $scope.sysConfigVars = _SYSTEM_CONFIG;
                $rootScope.systemConfig = _SYSTEM_CONFIG;

                // Global level variable applicable throughout application
                $rootScope.gblFontFamily = FONT_FAMILY;
                $rootScope.gblFontSize = FONT_SIZE;

                // if($state.current.appTitle != undefined && $state.current.appTitle != "") {
                //     $rootScope.appTitle = $state.current.appTitle;
                // }
                $rootScope.versionInfo = ''; 
                
                if($location.search().lang && $location.search().lang !="") {
                    publishDashboardLng = $location.search().lang;
                    $rootScope.selectedLangCode = publishDashboardLng;
                }
                
                // Need to assign the language that is stored in local storage
                if($rootScope.selectedLangCode == undefined) {
                    var currentTranslationObj = commonService.localStorage.getKeyValue('translation', false);
                    if(currentTranslationObj && currentTranslationObj.langCode) {
                        $rootScope.selectedLangCode = currentTranslationObj.langCode;
                    }
                }
                // end
                
            })();

            // Function to get version details
            commonService.getVersionInfoFromFile()
                .then(function (success) {
                    $rootScope.versionInfo = success;
                }, function (fail) {
                    errorService.show(fail);
            });

            // checks if user is authorized.
            $scope.isAuthorized = authService.isAuthorized;

            $scope.checkAuthorization = function (moduleName, action) {

                var isAuthorized = false;

                isAuthorized = authService.isAuthorized(moduleName, action)

                return isAuthorized;

            }

            // Listens to not authenticated event.            
            $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {                
                authService.destroySession();
                location.href = _WEBSITE_URL;
            })

            $rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
                $state.go('dfaBYD.notAuthorized');
            })

            $scope.login = function () { 
                var data = {
                    username: $scope.credentials.username,
                    pwd: commonService.encrypt($scope.credentials.password+sessionHash), //commonService.encrypt()
                    // To handle private dashboard login
                    loginflow: $rootScope.loginFromFlow, // none/private
                    additinalvars: $rootScope.additionalPostData, // additinal data to be posted
                }
                authService.login(data)
                    .then(function (usrData) {                                      
                        // added new code to show login on pop-up on preview page for Gallaery
                        if($rootScope.showLoginOnPopUp) {
                            $rootScope.showLoginOnPopUp = false;
                            if($rootScope.reloadCurrentScreen) {
                                //commonService.localStorage.setKeyValue('logoutFrom', '');
                                location.reload();
                            } else {
                                $rootScope.currentUser = usrData.data; 
                                commonService.localStorage.setKeyValue('currentUser', usrData.data);
                                // replace the html of login
                                $rootScope._SHOW_LOGIN_DETAILS_ = commonService.localStorage.getKeyValue('_SHOW_LOGIN_DETAILS_');
                            }
                        } else {
                            // get the glout from screen and then redirect to that screen
                            var logoutFromUrl = commonService.localStorage.getKeyValue('logoutFrom');
                            //commonService.localStorage.setKeyValue('logoutFrom', '');
                            if(usrData.data.role == 'Public') {
                                // Public User role                                
                                if(logoutFromUrl && logoutFromUrl!="") {                                
                                    location.href = logoutFromUrl;
                                } else {
                                    location.href = _WEBSITE_URL + '/#/Gallery';
                                }
                            } else if(usrData.data.role == 'Admin') {
                                // normal code
                                $state.go('dfaBYD.home.dashboardMgt');
                            } else {
                                //
                                //$state.go('dfaBYD.home.dashboardMgt');
                            }
                        }
                    }, function (err) { 
                        $scope.loginFailedMsg = errorService.resolve(err);
                        $scope.loginFailed = true;
                        $scope.credentials = {
                            username: '',
                            email: '',
                            password: ''
                        }
                    });
            }

            $scope.register = function () { 
                var data = {
                    username: $scope.registration.username,
                    pwd: commonService.encrypt($scope.registration.password+sessionHash), //commonService.encrypt()
                    fname: $scope.registration.fname,
                    lname: $scope.registration.lname,
                    email: $scope.registration.email,
                    cpwd: $scope.registration.confirm_password
                }
                authService.register(data)
                    .then(function (usrData) { 
                        // added new code to show login on pop-up on preview page for Gallaery
                        if($rootScope.showRegisterOnPopUp) {
                            $rootScope.showRegisterOnPopUp = false;
                            if($rootScope.reloadCurrentScreen) {
                                //commonService.localStorage.setKeyValue('logoutFrom', '');
                                location.reload();
                            }
                        } else {
                            // get the glout from screen and then redirect to that screen
                            var logoutFromUrl = commonService.localStorage.getKeyValue('logoutFrom');
                            //commonService.localStorage.setKeyValue('logoutFrom', '');
                            if(usrData.data.role == 'Public') {
                                // Public User role                                
                                if(logoutFromUrl && logoutFromUrl!="") {                                
                                    location.href = logoutFromUrl;
                                } else {
                                    location.href = _WEBSITE_URL + '/#/Gallery';
                                }
                            } else if(usrData.data.role == 'Admin') {
                                // normal code
                                $state.go('dfaBYD.home.dashboardMgt');
                            }
                        }
                    }, function (err) { //console.log(err);
                        $scope.loginFailedMsg = errorService.resolve(err);
                        $scope.loginFailed = true;
                        $scope.credentials = {
                            email: '',
                            password: ''
                        }
                    });
            }

            $scope.logout = function () {
                authService.logout()
                    .then(function () {
                        location.href = _WEBSITE_URL;
                    });
            }

            $scope.closeLoginFailedAlert = function () {
                $scope.loginFailed = false;
            }

            $rootScope.onLanguageChange = function () {
                var langDir = 'ltr';
                angular.forEach($rootScope.languageOptions, function (lang) {
                    if (lang.code == $rootScope.selectedLangCode) {
                        langDir = lang.rtl == true ? 'rtl' : 'ltr';
                    }
                })
                $rootScope.langDir = langDir;
                translationsService.setUserSelectedLanguage($rootScope.selectedLangCode, $rootScope.langDir);
                translationsService.setTranslationStrings($rootScope.selectedLangCode);
            }

            $rootScope.getTranslatedKey = function (key) {
                return translationsService.getTranslatedKey(key);
            }

             //encode Id to pass in URL
            $rootScope.encodeUrlId = function (id) {
                var str = "DFA%BYD=" + id;
                return window.btoa(window.btoa(str)) + "-" + id;
            }
            //decode Id to pass in URL
            $rootScope.decodeUrlId = function (encodeStr) {
                try{
                    if(encodeStr.indexOf("-") > 0){
                        var str = encodeStr.substring(0,encodeStr.indexOf("-"));
                        var decodeStr = window.atob(window.atob(str)).split("=")[1];
                        return Number(decodeStr);
                    }
                }
                catch(exception){
                    console.log(exception);
                }
                alert("Bad Request. It seems the parameters have been tampered with.");
                return false;
            }

            /**
             * Cancel login function in case login is opened on pop-up
             */
            $rootScope.cancelLogin = function() {
                $rootScope.showLoginOnPopUp = false;
                $rootScope.enableScrolling();
            }
            /**
             * Login function to be called on the dashboard for the public user on pop-up
             */
             $rootScope.dashboardLogin = function() {
                // Variable to know the login page is called from Private Dashboard Flow
                $rootScope.loginFromFlow = 'none';
                // Additional Post data Variable in case need to post additional data to the service
                $rootScope.additionalPostData = {};
                // Login form to be shown on poup on the same screen
                $rootScope.showLoginOnPopUp = true;
                // Register form to be shown on poup on the same screen
                $rootScope.showRegistrationLink = true;
                $rootScope.showRegisterOnPopUp = false;
                // Reload the current screen after login or registration
                $rootScope.reloadCurrentScreen = true;
                // Variable to show/hide Cancel button
                $rootScope.showCancelButton = true;
                // Variable to show/hide forgot password link
                $rootScope.showForgotPasswordLink = true;
                // Store the current url on storage
                commonService.localStorage.setKeyValue('logoutFrom', location.href);
                // Disable Scrolling
                $rootScope.disableScrolling();
            }
            /**
             * Register function to be called on the dashboard for the public user on pop-up
             */
             $rootScope.dashboardRegister = function() {
                // Login form to be shown on poup on the same screen
                $rootScope.showLoginOnPopUp = false;
                // Register form to be shown on poup on the same screen
                $rootScope.showRegisterOnPopUp = true;
                // Disable Scrolling
                $rootScope.disableScrolling();
            }
            /**
             * Logout function to be called on the dahsboard for public user
             * @param {*} redirectToLogin 
             */
            $rootScope.dashboardLogout = function (redirectToLogin) {
                authService.logout()
                    .then(function () {
                        // Store the current url on storage
                        //commonService.localStorage.setKeyValue('logoutFrom', location.href);
                        location.reload();
                        
                        // if(!redirectToLogin) {
                        //     // stay on same page 
                        //     location.reload();
                        // } else {                            
                        //     // redirect to login
                        //     location.href = _WEBSITE_URL;                            
                        // }                        
                    });
            }
            /**
             * Function to disable browser scrolling
             */
            $rootScope.disableScrolling = function(){
                var x=window.scrollX;
                var y=window.scrollY;
                window.scrollTo(0, 0);
                window.onscroll=function(){window.scrollTo(0, 0);};
            }
            /**
             * Function to enable browser scrolling
             */            
            $rootScope.enableScrolling = function(){
                window.onscroll=function(){};
            }
            /**
             * function to click on forgot password link for public user
             * @param {*} none 
             */
             $rootScope.forgotPasswordClicked = function () { 
                commonService.localStorage.setKeyValue('forgotPassFrom', location.href);
            }

            /** 
             * function to include font family in the web
             * @param fontSourceData array object
            */
            $rootScope.includeFontFamily = function (fontSourceData) {
                // Your font goes here
                /*const newFont = new FontFace('ALEGREYA SANS 100ITALIC', 'url(https://fonts.gstatic.com/s/alegreyasans/v21/5aUv9_-1phKLFgshYDvh6Vwt7V9V3G1WpGtLsgu7.ttf)');
                let fstyle = document.createElement('style');
                newFont.load().then(function(loadedFont) {
                    document.fonts.add(fstyle);
                    //document.head.appendChild(style);
                    console.log('Font loaded');
                }).catch(function(error) {
                    console.log('Failed to load font: ' + error);
                });*/
                if(fontSourceData) {
                    fontSourceData.forEach(element => {
                        if(element.font && element.src) {
                            let style = document.createElement('style');
                            style.innerText = "@font-face { font-family: '" + element.font + "'; src: url('" + element.src + "'); }";
                            document.head.appendChild(style);
                        }
                    });
                }
                
            }

            /**
             * Function to change body font style
             * @param {*} bodyFont 
             */
            $rootScope.chageFontToBody = function(bodyFont) {
                if(bodyFont && bodyFont.family) {
                    document.body.style.fontFamily = bodyFont.family;

                    let style = document.createElement('style');
                    style.innerHTML = "body,div { font-family: " + bodyFont.family + ";} svg.highcharts-root {font-family: " + bodyFont.family + " !important;}";
                    document.body.appendChild(style);
                }
                if(bodyFont && bodyFont.size) {
                    document.body.style.fontSize = bodyFont.size + 'px';
                }
                if(bodyFont && bodyFont.color) {
                    document.body.style.backgroundColor = bodyFont.color;
                }        
            }

        }
    ])
